import { render, staticRenderFns } from "./SchoolSubscribe.vue?vue&type=template&id=03556af4&scoped=true"
import script from "./SchoolSubscribe.vue?vue&type=script&lang=js"
export * from "./SchoolSubscribe.vue?vue&type=script&lang=js"
import style0 from "./SchoolSubscribe.vue?vue&type=style&index=0&id=03556af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03556af4",
  null
  
)

export default component.exports